import React from 'react';
import { Link } from 'react-router-dom';
import type { InventoryItem } from '../../types/inventory';
import { ProfileManager } from './ProfileManager';
import { InventoryRoastProfileButton } from './InventoryRoastProfileButton';
import { useLanguage } from '../../features/language/useLanguage';

interface IngredientsListProps {
  ingredients: InventoryItem[];
  onViewRoast: (item: InventoryItem) => void;
}

export const IngredientsList: React.FC<IngredientsListProps> = ({
  ingredients,
  onViewRoast,
}) => {
  const { t } = useLanguage();
  if (ingredients.length === 0) {
    return <div className="p-4 text-gray-500 text-sm italic">{t('inventory.ingredients.empty')}</div>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200 text-sm">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{t('forms.customer.itemName')}</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{t('inventory.ingredients.itemId')}</th>
            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">{t('purchasing.sampleList.table.greenBeanProfile')}</th>
            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">{t('purchasing.sampleList.table.roastProfile')}</th>
            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">{t('purchasing.sampleList.table.tasteProfile')}</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {ingredients.map((ingredient) => (
            <tr key={ingredient.id}>
              <td className="px-6 py-4 whitespace-nowrap text-gray-900 font-medium">{ingredient.name}</td>
              <td className="px-6 py-4 whitespace-nowrap text-gray-500">
                <Link to={`/inventory/items/${ingredient.id}`} className="text-primary-600 hover:text-primary-900 hover:underline">
                  {ingredient.code || ingredient.id.substring(0, 8)}
                </Link>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-center">
                <ProfileManager
                  entityType="ItemType"
                  entityId={ingredient.id}
                  profileType="greenBean"
                  readOnly={true}
                  fallbackText={t('inventory.modal.values.na')}
                />
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-center">
                <InventoryRoastProfileButton
                  item={ingredient}
                  onClick={() => onViewRoast(ingredient)}
                  fallbackText={t('inventory.modal.values.na')}
                />
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-center">
                <ProfileManager
                  entityType="ItemType"
                  entityId={ingredient.id}
                  profileType="cupping"
                  readOnly={true}
                  fallbackText={t('inventory.modal.values.na')}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
